import { Component, OnInit } from '@angular/core';
import { CoordinatePointsService } from 'src/app/services/coordinate-points.service';
import { MapService } from 'src/app/services/map.service';
import { PointsService } from 'src/app/services/points.service';
import olMap from 'ol/Map';
import { CoordinatePoint, CoordinatePointModel } from 'src/app/models/coordinate-point';
import { toLonLat } from 'ol/proj';
import { VicentyToolControlService } from 'src/app/services/vicenty-tool-control.service';
import { ToolsControlService } from 'src/app/services/tools-control.service';
import { ModalConfirmationService } from 'src/app/services/modal-confirmation.service';
import { MenuManagementService } from 'src/app/menu/services/menu-management.service';
import { TabsService } from 'src/app/services/tabsService';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CoordPointDuplicationWarningComponent } from 'src/app/popup/coord-point-duplication-warning/coord-point-duplication-warning.component';
import { CoordenateService } from 'src/app/services/coordenate.service';
import { ProjectService } from 'src/app/services/project.service';

@Component({
  selector: 'app-coordinate-points',
  templateUrl: './coordinate-points.component.html',
  styleUrls: ['./coordinate-points.component.scss'],
  standalone: false
})
export class CoordinatePointsComponent implements OnInit {


  primaryDataActive:boolean = true;
  coordinatePointsController : CoordinatePointsService;
  pointsController : PointsService;
  mapService : MapService;


  map:olMap;
  coordPointToSave:CoordinatePoint;

  constructor(coordinatePointsController : CoordinatePointsService, mapService : MapService, pointsController : PointsService,
    private toolsService : ToolsControlService, private vicentyTool : VicentyToolControlService, private confirmationModalService : ModalConfirmationService,
    public menuController : MenuManagementService,
    public tabsService: TabsService,
    public popupService : BsModalService,
    private rcsControl : CoordenateService,
    public projectService: ProjectService
    ) {
    this.coordinatePointsController = coordinatePointsController;
    this.pointsController = pointsController;
    this.mapService = mapService;
    this.map = this.mapService.getMap('map');
    this.coordinatePointsController.selectedCoordinatePoint = new CoordinatePointModel();
    // TODO: Move click listener to Service if click event is not necessary to be always running. And remove listener when not necessary anymore
    this.map.on('click', (evt) => {

      if(coordinatePointsController.active && !coordinatePointsController.editMode){
        var coords = toLonLat(evt.coordinate,this.rcsControl.activeRCS.isactive? this.rcsControl.activeRCS.epsg : "EPSG:3857");
        var lat = Math.round(coords[1] * 100000) / 100000;
        var lon = Math.round(coords[0] * 100000) / 100000;
        this.coordinatePointsController.selectedCoordinatePoint.latitude = lat;
        this.coordinatePointsController.selectedCoordinatePoint.longitude = lon;
        this.coordinatePointsController.selectedCoordinatePoint.latLonDms.fromLat(lat);
        this.coordinatePointsController.selectedCoordinatePoint.latLonDms.fromLon(lon);
      }
     });
   }

  ngOnInit(): void {
  }

  // Getter for 'published', inverse of 'userdefined'
  get published(): boolean {
    return !this.coordinatePointsController.selectedCoordinatePoint.userdefined;
  }

  // Setter for 'published', also inverses 'userdefined'
  set published(value: boolean) {
    this.coordinatePointsController.selectedCoordinatePoint.userdefined = !value;
  }

  cancelCoordinatePoint():void{
    this.coordinatePointsController.active = !this.coordinatePointsController.active;
    this.coordinatePointsController.selectedCoordinatePoint = new CoordinatePointModel();
    this.toolsService.navigationOnTop = false;
    this.coordinatePointsController.azimuthAndDistance = false;

  }

  public activatePrimaryData():void{
    this.primaryDataActive = true;
  }

  saveCoordinatePointValidation() : void {
    this.coordPointToSave = this.coordinatePointsController.getCoordinatePointPayload(this.coordinatePointsController.selectedCoordinatePoint);
    if(!this.coordinatePointsController.editMode || !this.coordinatePointsController.selectedCoordinatePointUserDefinedStatus){
      this.duplicateValidation();
      return;
    }
    this.coordPointToSave.userdefined = true;
    this.confirmationModalService.showMesssageConfirmationModal("Save Coordinate Point",
      "You are editing a published Coordinate Point, do you wish to continue and save the changes?", "OK", "Cancel",
      () => this.duplicateValidation());


  }




  duplicateValidation(){
    const duplicates = this.pointsController.getDuplicates(this.coordinatePointsController.selectedCoordinatePoint)
    if(duplicates.length>0){
      this.tabsService.saveCurrentTab();
      let bsRef: BsModalRef = this.popupService.show(CoordPointDuplicationWarningComponent, {
        backdrop: 'static' // Prevent closing on backdrop click
      });
      bsRef.content.duplicateCoordinatePoints = duplicates
      bsRef.content.onUserResponse.subscribe((result) =>{
        switch(result){
          case CoordPointDuplicationWarningComponent.CANCEL:
            this.tabsService.showTab(this.tabsService.currentIndex);
            break;
          case CoordPointDuplicationWarningComponent.PROCEED:
            this.saveCoordinatePoint();
            break;
        }
      }
      )
      return;
    }
    this.saveCoordinatePoint();
  }
  saveCoordinatePoint():void{
    if(this.coordinatePointsController.azimuthAndDistance){
      let value:number[] = VicentyToolControlService.calculateDestinationPoint(this.coordinatePointsController.selectedCoordinatePoint.latitude, this.coordinatePointsController.selectedCoordinatePoint.longitude,
        this.coordinatePointsController.azimuth, this.coordinatePointsController.distance);
      this.coordPointToSave.latitude = value[0];
      this.coordPointToSave.longitude = value[1];
      this.coordinatePointsController.azimuthAndDistance = false;
    }

    this.pointsController.saveCoordinatePoint(this.coordPointToSave);
    this.tabsService.closeTab();
    this.coordinatePointsController.active = !this.coordinatePointsController.active;
    this.toolsService.navigationOnTop = false;
  }

  isValueValid(type : string, value : any) : void {

    if (value != null) {
      switch(type) {
        case "Maximum_Altitude":
          if (!(Number.parseFloat(value) >= 0 && Number.parseFloat(value) <= 60000)){
            this.coordinatePointsController.selectedCoordinatePoint.maxaltitude = null;
            this.coordinatePointsController.selectedCoordinatePoint.maxaltitudeMeters = null;
            this.coordinatePointsController.maxAltitudeValid = false;
          }else {
            this.coordinatePointsController.maxAltitudeValid = true;
          }
          break;
          case "Minimum_Altitude":
            if (!(Number.parseFloat(value) >= 0 && Number.parseFloat(value) <= 60000)){
              this.coordinatePointsController.selectedCoordinatePoint.minaltitude = null;
              this.coordinatePointsController.selectedCoordinatePoint.minaltitudeMeters = null;
              this.coordinatePointsController.minAltitudeValid = false;
            }else {
              this.coordinatePointsController.minAltitudeValid = true;
            }
            break;
          case "Azimuth":
            if (!(Number.parseFloat(value) >= 0 && Number.parseFloat(value) <= 360)){
              this.coordinatePointsController.azimuth = null;
              this.coordinatePointsController.azimuthValid = false;
            }else {
              this.coordinatePointsController.azimuthValid = true;
            }
            break;
          case "Distance":
            if (!(Number.parseFloat(value) >= 0 && Number.parseFloat(value) <= 3.4028235E38)){

              this.coordinatePointsController.distance = null;
              this.coordinatePointsController.distanceValid = false;
            }else {
              this.coordinatePointsController.distanceValid = true;
            }
            break;
          case "latitude":
            this.coordinatePointsController.setValidationValid(true);
            if (!(Number.parseFloat(value) >= -90 && Number.parseFloat(value) <= 90)){

              this.coordinatePointsController.selectedCoordinatePoint.latitude = null;
              this.coordinatePointsController.selectedCoordinatePoint.latLonDms.latitude.degrees = null;
              this.coordinatePointsController.selectedCoordinatePoint.latLonDms.latitude.minutes = null;
              this.coordinatePointsController.selectedCoordinatePoint.latLonDms.latitude.seconds = null;
              this.coordinatePointsController.latitudeValid = false;
            }else {
              this.coordinatePointsController.latitudeValid = true;
            }
            break;
          case "lat_degrees":
            if (!(Number.parseFloat(value) >= 0 && Number.parseFloat(value) <= 90 && Number.isInteger(value))){

              this.coordinatePointsController.selectedCoordinatePoint.latLonDms.latitude.degrees = null;
              this.coordinatePointsController.lat_degreesValid = false;
            }else {
              this.coordinatePointsController.lat_degreesValid = true;
            }
            break;
          case "lat_minutes":
            if (!(Number.parseFloat(value) >= 0 && Number.parseFloat(value) <= 59 && Number.isInteger(value))){

              this.coordinatePointsController.selectedCoordinatePoint.latLonDms.latitude.minutes = null;
              this.coordinatePointsController.lat_minutesValid = false;
            }else {
              this.coordinatePointsController.lat_minutesValid = true;
            }
            break;
          case "lat_seconds":
            if (!(Number.parseFloat(value) >= 0 && Number.parseFloat(value) <= 59.99)){

              this.coordinatePointsController.selectedCoordinatePoint.latLonDms.latitude.seconds = null;
              this.coordinatePointsController.lat_secondsValid = false;
            }else {
              this.coordinatePointsController.lat_secondsValid = true;
            }
            break;
          case "longitude":
            this.coordinatePointsController.setValidationValid(true);
            if (!(Number.parseFloat(value) >= -180 && Number.parseFloat(value) <= 180)){

              this.coordinatePointsController.selectedCoordinatePoint.longitude = null;
              this.coordinatePointsController.selectedCoordinatePoint.latLonDms.longitude.degrees = null;
              this.coordinatePointsController.selectedCoordinatePoint.latLonDms.longitude.minutes = null;
              this.coordinatePointsController.selectedCoordinatePoint.latLonDms.longitude.seconds = null;
              this.coordinatePointsController.longitudeValid = false;
            }else {
              this.coordinatePointsController.longitudeValid = true;
            }
            break;
          case "lon_degrees":
            if (!(Number.parseFloat(value) >= 0 && Number.parseFloat(value) <= 180 && Number.isInteger(value))){

              this.coordinatePointsController.selectedCoordinatePoint.latLonDms.longitude.degrees = null;
              this.coordinatePointsController.lon_degreesValid = false;
            }else {
              this.coordinatePointsController.lon_degreesValid = true;
            }
            break;
          case "lon_minutes":
            if (!(Number.parseFloat(value) >= 0 && Number.parseFloat(value) <= 59 && Number.isInteger(value))){

              this.coordinatePointsController.selectedCoordinatePoint.latLonDms.longitude.minutes = null;
              this.coordinatePointsController.lon_minutesValid = false;
            }else {
              this.coordinatePointsController.lon_minutesValid = true;
            }
            break;
          case "lon_seconds":
            if (!(Number.parseFloat(value) >= 0 && Number.parseFloat(value) <= 59.99)){

              this.coordinatePointsController.selectedCoordinatePoint.latLonDms.longitude.seconds = null;
              this.coordinatePointsController.lon_secondsValid = false;
            }else {
              this.coordinatePointsController.lon_secondsValid = true;
            }
            break;

        default:
          break;
      }
    }

  }


}
